import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-version-info',
    templateUrl: './version-info.component.html',
    styleUrls: ['./version-info.component.css'],
    standalone: false
})
export class VersionInfoComponent implements OnInit {

  @Input() name;
  @Input() version;
  @Input() buildDate;

  ngOnInit(): void {

  }

}
